import { firestoreAction } from 'vuexfire'
import db from '../firebase'
import sha512 from "crypto-js/sha512";

const state = {
  f:[],
  teachers: [],
  teachersFetched: false,
  teacher: null,
  loggedIn: false,
  casesFetched: false,
  FFetched: false,
  cases:[]
}
const getters = {
  f: (state) => {
    return state.f
  },
  teachers: (state) => {
    return state.teachers
  },
  cases: (state) => {
    return state.cases
  },
  loggedInteacher: (state) => {
    return state.loggedIn
  },
  casesFetched: (state) => {
    return state.casesFetched
  },
  FFetched: (state) => {
    return state.FFetched
  },
  feedback: (state) => {
    return state.cases.filter(C=> C.hasOwnProperty('feedback'))
  },
  teachersFetched: (state) => {
    return state.teachersFetched
  },
  teacher: (state) => {
    return state.teacher
  },
  teachernames: (state) => {
    return state.teachers.map(teacher => teacher.name)
  },
  teachernameandId: (state) => {
    return state.teachers.map(teacher => [teacher.name, teacher.id])
  }
}
const mutations={
//   login_teacher(state,teacher){
//      (teacher)
//      (state.teacher)
// state.teacher.name="Adam";
//   },
add_Case(state,Case){
  state.cases.push(Case);
    },
update_Cases(state,Cases){
  state.cases=Cases;
    },
  logout_teacher(state){
state.teacher=null;
state.loggedIn=false;
state.casesFetched=false;
state.cases=[];
state.FFetched=false;
state.f=[];
  }
}
const actions = {
  initteachers: firestoreAction(({ bindFirestoreRef,state  }, SchoolId) => {
    bindFirestoreRef('teachers', db.collection('teachers').where('schoolId', '==', SchoolId)).then((res) => {
      // //console.log(res)
      if (res!=null) {
     res.forEach(teacher => {
        delete teacher.password;
      });
    }
      state.teachersFetched=true;   
    })

  }),


  initF: firestoreAction(({ bindFirestoreRef, state }, Teacher) => {
    // //console.log(Teacher)
    bindFirestoreRef('f', db.collection('nursecheck').where('schoolId', '==', Teacher.schoolId).where('reporter', '==', Teacher.name)) //.where('activity', 'in', ['f', 'f-varning'])
    .then(() => {

     state.FFetched=true
    })
  }),

  logoutTeacher ({commit}) {
      commit('logout_teacher')
      // this.$router.replace('login')
  },
  
  initcases({state},Cl){
    //  //console.log(Cl)
    let cases=[];
    // db.collection('cases').where('schoolId', '==', state.teacher.schoolId).where("subscribersId", 'array-contains', state.teacher.id).get().then(function (querySnapshot) {
      db.collection('cases').where('schoolId', '==', state.teacher.schoolId).where('class', 'in' ,Cl.map(klass=> klass.id)).get().then(function (querySnapshot) {
    
      querySnapshot.forEach(function (doc) {
                const id = doc.id
                const data = doc.data()
          data.id=id;
          //  (data)

                // Object.assign({}, id, { ...data })
                cases.push(data)
              })
              state.casesFetched=true;
              state.cases= cases
            })
           
      },

  loginteacher({state},data){
let loggedin=false;
let Teacher=null;
    db.collection("teachers").where('mail', '==', data[0]).where('password', '==', sha512(data[1]).toString()).get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            Teacher=doc.data()
              loggedin=true;
            Teacher.id =doc.id
          })
        })
        .then(() => {
              delete Teacher.newPassword;
              delete Teacher.password;
            state.teacher=Teacher
            state.loggedIn=loggedin;
            if (loggedin==true) {
              //  (Teacher)
              if (!Teacher.hasOwnProperty('lastOnline')) {
                Teacher.lastOnline=Date.now();
              }
              
              Teacher.oldLastOnline=Teacher.lastOnline;
              //  (Teacher)
              Teacher.lastOnline=Date.now();
              db.collection('teachers').doc(Teacher.id).update(Teacher)
            }
            return loggedin
        })            .catch((err) => {
           (err)
          state.loggedIn=loggedin;
        })
  },

  removeteacher({commit},teacherId){
    db.collection('teachers').doc(teacherId).delete()
  },
  saveteacher({},teacher){
    db.collection('teachers').doc(teacher.id).update(teacher)
  },
  updateCases({commit},cases){
  
    commit('update_Cases',cases)
  },
  addCase({commit},Case){
  
    commit('add_Case',Case)
  },
  createteacher({},teacher){
    
    teacher.lastOnline=  Date.now() 
    db.collection('teachers').add(
      teacher
    );
      },
 
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
